import _ from 'lodash';

export const convertEnumValueToSlug = <T>(enumValue: T): string =>
  _.chain(enumValue).toLower().replace(/_/g, '-').value();

export const convertSlugToEnumValue = <T>(
  slug: string,
  enumObj: { [key: string]: T }
): T => {
  const enumValue = _.chain(slug)
    .toUpper()
    .replace(/\-/g, '_')
    .value() as unknown as T;
  return _.includes(enumObj, enumValue) ? enumValue : null;
};
